import * as React from "react";
import * as Utils from "@Cyclope-Utils/index";
import DatePicker from "@tunnel-components/@sharded/@widgets/dataPicker";
// import { pure } from 'recompose';
import * as shortid from "shortid";
import CheckBoxGrid from "@tunnel-components/@sharded/@widgets/checkbox/component";
// import CheckBoxInput from '@tunnel-components/@sharded/widgets/forms/input/checkbox/custom/component';
import RadioInput from "@tunnel-components/@sharded/widgets/forms/input/radio/custom/component";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import * as Lodash from "lodash";
import * as i18next from "i18next";
import * as cx from "classnames";
import SelectGrid from "@tunnel-components/@sharded/@widgets/select";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    IncidentTypeData,
    SectionData,
    startDate,
    isVisible,
    cameraFirstSelect,
    error,
    faillure,
    spinner,
    selectedOptionsSecondCamera,
    selectedOptionsFirstCamera,
    camera,
    onSelectCamera,
    endDate,
    onSelectFirstCamera,
    perimetre,
    cameraArray,
    onChoiceCamera,
    onStartDateChange,
    onEndDateChange,
    onClose,
    onSubmit,
    radio,
    checkedItems,
    onChangeNameRadio,
    onChangeName,
  } = props;

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name section
   * @type { JSX.Element }
   */
  const section: JSX.Element[] =
    SectionData &&
    Utils.transformObjectToArray(SectionData).map((Elem: any, index: any) => {
      return (
        <RadioInput
          key={shortid.generate()}
          name="radio"
          id={`modal-${Elem.id}`}
          checked={radio[index]}
          onChecked={onChangeNameRadio(index)}
          label={Elem.name}
        />
      );
    });

  /**
   * @description : retourne un tableau de type Any
   * @const
   * @name filterwithoutFast
   * @type { any }
   */
  const filterwithoutFast: any[] =
    !Lodash.isNull(IncidentTypeData) &&
    !Lodash.isUndefined(IncidentTypeData) &&
    Utils.transformObjectToArray(IncidentTypeData).filter(
      (elem: any) => elem !== null
    );

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name Settings
   * @type { JSX.Element  }
   */
  const Settings: JSX.Element[] =
    filterwithoutFast &&
    filterwithoutFast.map((Elem: any, index: number) => {
      return (
        <div className="checkBoxInhibition" key={index}>
          <div className="checkBoxInhibitionContent left">
            <CheckBoxGrid
              name={i18next.t(`${Elem.label}`)}
              checked={checkedItems[index]}
              id={Elem.id}
              onChecked={onChangeName(index)}
            />
          </div>
          <div className="checkBoxInhibitionContent left">
            {i18next.t(`${Elem.label}`)}
          </div>
        </div>
      );
    });

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name i18next
   * @name lodash
   * @name shortid
   * @name react-datepicker
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isVisible}>
      <StyledComponent.ModalContainerInsider
        isVisible={isVisible}
        style={{
          overflow: "visible",
          width: "660px",
          backgroundColor: "unset",
        }}
      >
        {isVisible && (
          <BoxGrid
            title={i18next.t("PARAMETRAGE D'INHIBITION")}
            classNames="boderShadow"
            onClose={onClose}
            onSubmit={!spinner ? onSubmit : undefined}
            BtnTextSpan={i18next.t("enregistrer")}
          >
            <Styled.CartContainer>
              <div className="extractionInfo left">
                <div className={cx("titleAction")}>
                  <h2>{i18next.t("incidents")}: </h2>
                  <div className="listBtnRadio">{Settings}</div>
                </div>
              </div>
              <div className="extractionInfo left">
                <div className={cx("titleAction")}>
                  <h2>{i18next.t("plage horaire")} : </h2>

                  <div className="blockDatePicker ">
                    <DatePicker
                      placeholder={i18next.t("date de debut")}
                      selectedValue={startDate}
                      error={error}
                      onChangeSelected={onStartDateChange}
                    />
                  </div>

                  <div className="blockDatePicker ">
                    <DatePicker
                      placeholder={i18next.t("date de fin")}
                      error={error}
                      selectedValue={endDate}
                      onChangeSelected={onEndDateChange}
                    />
                  </div>
                </div>
                <div className={cx("titleAction")}>
                  <h2>{i18next.t("perimetres")} : </h2>
                  <div className="sectionContent">
                    {section}
                    {
                      <div className="cameraFisrtSelection">
                        <RadioInput
                          key="cm-89Yx-xx"
                          name="camera"
                          id="cm-89Yx"
                          checked={camera}
                          onChecked={onChoiceCamera}
                          label={i18next.t("sur camera")}
                        />

                        <div style={{ width: "100%" }}>
                          {selectedOptionsFirstCamera && camera && (
                            <div className="blockDatePicker ">
                              <SelectGrid
                                error={false}
                                selectedValueProps={cameraArray[0]}
                                cameraAndSection={true}
                                selectedOptions={selectedOptionsFirstCamera}
                                onGetIdentifiantItem={onSelectFirstCamera}
                                placeholder={i18next.t("camera de debut")}
                              />
                            </div>
                          )}

                          {cameraFirstSelect && (
                            <div className="blockDatePicker ">
                              <SelectGrid
                                selectedValueProps={cameraArray[1]}
                                error={false}
                                camera={true}
                                selectedOptions={selectedOptionsSecondCamera}
                                onGetIdentifiantItem={onSelectCamera}
                                placeholder={i18next.t("camera de fin")}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </Styled.CartContainer>
          </BoxGrid>
        )}
      </StyledComponent.ModalContainerInsider>
      <SnackBar
        style={{ backgroundColor: "#00E1B3" }}
        isVisible={spinner}
        someTextSuccees={i18next.t("creation en cours")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={faillure}
        someTextSuccees={i18next.t("la creation de l'inhibition a echoue")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={error}
        someTextSuccees={i18next.t(
          "les champs invalides : veuillez remplir les champs"
        )}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={perimetre}
        someTextSuccees={i18next.t("veuillez choisir un perimetre")}
      />
    </StyledComponent.ModalContainer>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {
  camera: false,
  cameraFirstSelect: false,
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  IncidentTypeData?: any;
  SectionData?: any;
  cameraFirstSelect?: any;
  isVisible?: boolean;
  error?: any;
  faillure?: any;
  spinner?: any;
  selectedOptionsSecondCamera?: any;
  perimetre?: boolean;
  selectedOptionsFirstCamera?: any;
  camera?: any;
  selectedCameraEnd?: any;
  onSelectCamera?: any;
  selectedCameraStart?: any;
  onSelectFirstCamera?: any;

  onChoiceCamera?: any;
  onStartDateChange?: any;
  startDate?: any;
  onEndDateChange?: any;
  endDate?: any;
  cameraArray?: any;
  onClose?: any;
  onSubmit?: any;
  radio?: any;
  checkedItems?: any;
  onChangeNameRadio?: any;
  onChangeName?: any;
}
/** @export HOC pure */
export default React.memo(Component);
// export default Component;



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/inhibitions/created/component.tsx